import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { COMPONENT_NAME } from '../../../constants';
import PersonIdentifier from '../../../components/cms/admin/accounts/EnrichmentRule/retrieve/PersonIdentifier';

const ContentChildLv2 = () => {
     const { componentLv2, ruleIdLv2, timeZone } = useSelector((state) => state.admin.flexibleModal);

     const getComponentFlexibleModal = useCallback(() => {
          switch (componentLv2) {
               case COMPONENT_NAME.ADMIN_PERSON_IDENTIFIER:
                    return <PersonIdentifier attributes={{id: ruleIdLv2, timeZone}} />;
               default:
                    return <></>;
          }
     }, [componentLv2, ruleIdLv2, timeZone]);

     return <>{getComponentFlexibleModal()}</>;
};
export default ContentChildLv2;
